import { gql } from '@apollo/client';

export const getPersonDetailsForm = gql(`
    query getPersonalInfoEnums {
      PersonType: __type(name: "PersonType") {
        name
        enumValues {
          name
          __typename
        }
        __typename
      }
      PhoneType: __type(name: "PhoneType") {
        name
        enumValues {
          name
        }
      }
      Gender: __type(name: "Gender") {
        name
        enumValues {
          name
        }
      }
      MaritalStatus: __type(name: "MaritalStatus") {
        name
        enumValues {
          name
        }
      }
      PersonRelation: __type(name: "PersonRelation") {
        name
        enumValues {
          name
        }
      }
      core {
        getTitles {
          id
          code
          title
        }
        getCountries {
          id
          code
          title
        }
        getNationalities {
          id
          code
          title
        }
        getOccupationClass{
          id
          code
          title
        }
      }
      salesforce {
        getAllPersons {
          id
          code
          fullName
        }
      }
    }
  `);

export const getAdditionalInformationEnums = gql`
  query getAdditionalInformationEnums {
    Gender: __type(name: "Gender") {
      name
      enumValues {
        name
      }
    }
    MaterialStatus: __type(name: "MaterialStatus") {
      name
      enumValues {
        name
      }
    }
    core {
      getCountries {
        id
        code
        title
      }
      getNationalities {
        id
        code
        title
      }
    }
  }
`;

export const getPersonAddressDetails = gql`
  query getPersonAddressDetails($personAddressId: String!) {
    salesforce {
      getPersonAddressDetails(personAddressId: $personAddressId) {
        addressType
        createdBy
        createdOn
        id
        isPrimary
        modifiedBy
        modifiedOn
        personId
        status
        address {
          addressDetails
          addressDetailsArabic
          building
          city
          country
          street
          zone
        }
      }
    }
  }
`;

export const getPersonAddressLovs = gql`
  query getPersonAddressLovs {
    PersonAddressType: __type(name: "PersonAddressType") {
      name
      enumValues {
        name
      }
    }
    core {
      getCountries {
        id
        code
        title
      }
      getZones {
        id
        code
        title
      }
    }
  }
`;

export const getActivePersonsList = gql`
  query {
    salesforce {
      getActivePersons {
        id
        fullName
        email
        phoneDetails {
          phoneNumber
          phoneType
        }
        isTaxable
      }
    }
  }
`;

export const getActivePersonsWithoutBusinessPartners = gql`
  query {
    salesforce {
      getActivePersonsWithoutBusinessPartners {
        id
        fullName
        status
      }
    }
  }
`;

export const getBusinessPartnerTypeEnums = gql`
  query {
    BusinessPartnerType: __type(name: "BusinessPartnerType") {
      name
      enumValues {
        name
      }
    }
  }
`;

export const getCountriesList = gql`
  query {
    core {
      getCountries {
        id
        title
        code
      }
    }
  }
`;

export const getCurrenciesList = gql`
  query {
    core {
      getCurrencies {
        id
        title
        code
        symbol
      }
    }
  }
`;

export const getPersonDetailsList = gql`
  query getPersonDetails($id: String!) {
    salesforce {
      getPersonDetails(id: $id) {
        email
        phoneDetails {
          phoneNumber
          phoneType
        }
      }
    }
  }
`;

export const getRelatedCompaniesList = gql`
  query {
    salesforce {
      getRelatedCompanies {
        id
        title
        code
      }
    }
  }
`;

export const getTitlesList = gql`
  query {
    core {
      getTitles {
        id
        title
        code
      }
    }
  }
`;

export const getZonesList = gql`
  query {
    core {
      getZones {
        id
        title
        code
      }
    }
  }
`;

export const getVignetteRangeDetails = gql`
  query getVignetteRangeDetails($id: String!) {
    salesforce {
      getBusinessPartnerVignetteRangeById(id: $id) {
        businessPartnerID
        createdBy
        createdOn
        id
        modifiedBy
        modifiedOn
        rangeFrom
        rangeTo
        status
        vignetteCode
        vignetteYear
        businessPartner {
          auxiliaryAccount
          code
          createdBy
          createdOn
          fullName
          hasAccessToAllInsured
          id
          isCompany
          isLocal
          isRegistered
          maxCreditLimitAllowed
          maxCreditLimitAllowedCurrency
          modifiedBy
          modifiedOn
          personId
          registerationExpiryDate
          registerationNumber
          relatedCompany
          status
          taxAuxiliaryAccount
          totalCreditLimitReached
          type
        }
      }
    }
  }
`;

export const getVignetteRangeStatusLOV = gql`
  query getVignetteRangeStatusLOV {
    VignetteStatus: __type(name: "VignetteStatus") {
      name
      enumValues {
        name
      }
    }
  }
`;

export const getBusinessUserLovs = gql`
  query getBusinessUserLovs {
    UserStatus: __type(name: "UserStatus") {
      name
      enumValues {
        name
      }
    }
    UserType: __type(name: "UserType") {
      name
      enumValues {
        name
      }
    }
    PersonAddressType: __type(name: "PersonAddressType") {
      name
      enumValues {
        name
      }
    }
    core {
      getUserAccesses {
        code
        title
        id
      }
      getRoles
      getTitles {
        code
        title
        id
      }
      getCountries {
        code
        title
        id
      }
      getZones {
        code
        title
        id
      }
    }
    salesforce {
      searchPersons(
        pagination: { pageNumber: 1, pageSize: 1000 }
        selectedTypes: ["INDIVIDUAL"]
        selectedStatuses: ["ACTIVE"]
      ) {
        items {
          id
          fullName
          userId
        }
      }
    }
  }
`;

export const getPersonDetailsById = gql`
  query getPersonDetailsById($personId: String!) {
    salesforce {
      getPersonById(personId: $personId) {
        email
        firstName
        lastName
        middleName
        title
        phoneDetails {
          phoneNumber
          phoneType
        }
      }
    }
  }
`;

export const checkBusinessUserByPerson = gql`
  query checkBusinessUserByPerson($selectedPersonID: String!) {
    SalesforceManagement {
      queries {
        checkBusinessUserByPerson(selectedPersonID: $selectedPersonID) {
          salesforceManagement_BusinessUser_Id
          salesforceManagement_BusinessUser_PersonID {
            id
            views {
              SalesforceManagement_all {
                properties {
                  FullName
                  PersonCode
                }
              }
            }
          }
          salesforceManagement_BusinessUser_Status
        }
      }
    }
  }
`;

export const getPersonEmailDetailsInfo = gql`
  query getPersonEmailDetailsInfo($id: String!) {
    SalesforceManagement {
      entities {
        person(id: $id) {
          views {
            SalesforceManagement_all {
              properties {
                Email
              }
            }
          }
        }
      }
    }
  }
`;

export const getExportPoliciesLOVs = gql`
  query GetExportPoliciesLOVs {
    PolicyStatusList: __type(name: "PolicyStatusList") {
      enumValues {
        name
      }
    }
    production {
      getPolicyOwners {
        id
        firstName
        middleName
        lastName
      }
      getProposalBusinessPartners {
        id
        code
        fullName
      }
    }
    core {
      getCurrencies {
        id
        code
        title
      }
    }
  }
`;

export const searchPoliciesForExport = gql`
  query searchPoliciesForExport(
    $currentPage: Int!
    $currentPageSize: Int!
    $selectedUsers: [String!]
    $selectedBusinessPartners: [String!]
    $effectiveOnStart: DateTime
    $effectiveOnEnd: DateTime
    $expiryOnStart: DateTime
    $expiryOnEnd: DateTime
    $issueDateStart: DateTime
    $issueDateEnd: DateTime
    $createdOnStart: DateTime
    $createdOnEnd: DateTime
    $Attribute: String!
    $Descending: Boolean!
  ) {
    production {
      searchPolicies(
        pagination: { pageNumber: $currentPage, pageSize: $currentPageSize }
        orderBy: { attribute: $Attribute, descending: $Descending }
        users: $selectedUsers
        businessPartners: $selectedBusinessPartners
        effectiveOnStart: $effectiveOnStart
        effectiveOnEnd: $effectiveOnEnd
        expiryOnStart: $expiryOnStart
        expiryOnEnd: $expiryOnEnd
        issueDateStart: $issueDateStart
        issueDateEnd: $issueDateEnd
        createdOnStart: $createdOnStart
        createdOnEnd: $createdOnEnd
      ) {
        paging {
          pageNumber
          pageSize
          totalCount
        }
        items {
          policyNumber
          plan {
            code
            name
          }
          user {
            code
            firstName
            middleName
            lastName
          }
          mainBusinessPartner {
            code
            fullName
          }
          policyEffectiveDate
          policyExpiryDate
          policyIssueDate
          policyCurrency {
            id
            title
          }
          isRenewal
          renewalFrom {
            policyNumber
          }
          isRenewed
          renewalTo {
            policyNumber
          }
          policyStatus
          statusReason
          policyPersons {
            firstName
            lastName
            passportNumber
            phoneNumber
            dateOfBirth
            relation
            person {
              phoneDetails {
                phoneNumber
              }
            }
            personAddress {
              address {
                city
                addressDetails
              }
            }
          }
        }
      }
    }
  }
`;

export const getExportAmendmentsLOVs = gql`
  query getExportAmendmentsLOVs {
    AmendmentStatusList: __type(name: "AmendmentStatusList") {
      enumValues {
        name
      }
    }
  }
`;

export const searchAmendments = gql`
  query searchAmendments(
    $pagination: PaginationInput!
    $orderBy: OrderByInput
    $effectiveOnStart: DateTime
    $effectiveOnEnd: DateTime
    $createdBy: [String!]
    $statuses: [String!]
    $createdOnStart: DateTime
    $createdOnEnd: DateTime
  ) {
    production {
      searchAmendments(
        pagination: $pagination
        orderBy: $orderBy
        effectiveOnStart: $effectiveOnStart
        effectiveOnEnd: $effectiveOnEnd
        statuses: $statuses
        createdOnStart: $createdOnStart
        createdOnEnd: $createdOnEnd
        createdBy: $createdBy
      ) {
        items {
          createdOn
          referenceNumber
          amendmentType
          amendmentReason
          amendmentEffectiveDate
          status

          policy {
            policyStatus
            statusReason
            policyNumber
            policyEffectiveDate
            policyExpiryDate
            policyIssueDate
            policyCurrency {
              title
            }
            plan {
              code
              name
            }
            user {
              id
              code
              firstName
              middleName
              lastName
            }
            mainBusinessPartner {
              id
              code
              fullName
            }
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const getProviderLOVs = gql`
  query {
    salesforce {
      getProviderTypes {
        id
        title
        code
      }
      getActivePersonsNonProvider {
        id
        fullName
        email
        phoneDetails {
          phoneNumber
          phoneType
        }
        isTaxable
      }
    }
    providerStatusList: __type(name: "ProviderStatusList") {
      name
      enumValues {
        name
      }
    }
    personAddressType: __type(name: "PersonAddressType") {
      name
      enumValues {
        name
      }
    }
    phoneType: __type(name: "PhoneType") {
      name
      enumValues {
        name
      }
    }
  }
`;
export const getAccountingTransferLovs = gql`
  query getAccountingTransferLovs {
    accounting {
      getTransferTypeLookup {
        id
        code
        title
        createdOn
        modifiedOn
      }
    }
  }
`;
export const getAmendmentSubtypesQuery = gql`
  query getAmendmentSubTypes {
    production {
      getAmendmentSubTypes {
        id
        code
        title
        createdOn
        modifiedOn
      }
    }
  }
`;

export const getSystemReferenceDateQuery = gql`
  query getSystemReferenceDate {
    core {
      getSystemReferenceDate
    }
  }
`;

export const getProposalLovs = gql`
  query getProposalLovs($lineIDs: [String!], $sublineIDs: [String!]) {
    production {
      getProposalActiveBusinessPartners {
        id
        fullName
        code
      }
      getProposalLines(status: "Active") {
        id
        code
        name
      }
      getProposalSublines(lineIDs: $lineIDs, status: "ACTIVE") {
        id
        code
        name
      }
      getProposalPlans(
        lineIDs: $lineIDs
        sublineIDs: $sublineIDs
        status: "Active"
      ) {
        name
        code
        id
        planCurrency
      }
    }
    core {
      getCurrencies {
        id
        code
        title
        symbol
      }
    }
  }
`;

// Export Proposals Queries
export const getExportProposalsLOVs = gql`
  query GetExportProposalsLOVs {
    ProposalStatusList: __type(name: "ProposalStatusList") {
      name
      enumValues {
        name
      }
    }
    production {
      getProposalBusinessPartners {
        id
        code
        fullName
      }
    }
    core {
      getCurrencies {
        id
        code
        title
      }
    }
  }
`;

export const searchUsersForExport = gql`
  query SearchUsersForExport(
    $keyword: String
    $pageNumber: Int!
    $pageSize: Int!
  ) {
    core {
      searchUsers(
        pagination: { pageNumber: $pageNumber, pageSize: $pageSize }
        keyword: $keyword
      ) {
        items {
          id
          code
          firstName
          middleName
          lastName
        }
      }
    }
  }
`;

export const searchProposalsForExport = gql`
  query searchProposalsForExport(
    $currentPage: Int!
    $currentPageSize: Int!
    $selectedBusinessPartners: [String!]
    $effectiveOnStart: DateTime
    $effectiveOnEnd: DateTime
    $expiryOnStart: DateTime
    $expiryOnEnd: DateTime
    $issueOnStart: DateTime
    $issueOnEnd: DateTime
    $createdOnStart: DateTime
    $createdOnEnd: DateTime
    $Attribute: String!
    $Descending: Boolean!
    $selectedUsers: [String!]
  ) {
    production {
      searchProposals(
        pagination: { pageNumber: $currentPage, pageSize: $currentPageSize }
        orderBy: { attribute: $Attribute, descending: $Descending }
        businessPartners: $selectedBusinessPartners
        effectiveOnStart: $effectiveOnStart
        effectiveOnEnd: $effectiveOnEnd
        expiryOnStart: $expiryOnStart
        expiryOnEnd: $expiryOnEnd
        issueOnStart: $issueOnStart
        issueOnEnd: $issueOnEnd
        createdOnStart: $createdOnStart
        createdOnEnd: $createdOnEnd
        users: $selectedUsers
      ) {
        paging {
          pageNumber
          pageSize
          totalCount
        }
        items {
          name
          plan {
            code
            name
          }
          mainBusinessPartner {
            code
            fullName
          }
          user {
            id
            code
            firstName
            lastName
          }
          policyEffectiveDate
          policyExpiryDate
          policyIssueDate
          policyCurrency {
            id
            title
          }
          isRenewal
          renewalFrom {
            name
            policyNumber
          }
          status
          statusReason
        }
      }
    }
  }
`;

export const getPoliciesForClaimLov = gql`
  query getPoliciesForClaimLov(
    $pagination: PaginationInput!
    $keyword: String
  ) {
    production {
      searchPolicies(
        pagination: $pagination
        keyword: $keyword
        statuses: ["Inforce", "InProgress", "Expired"]
      ) {
        items {
          id
          policyNumber
          policyEffectiveDate
          policyExpiryDate
        }
        paging {
          totalCount
        }
      }
    }
  }
`;

export const getPolicyPolicyPersons = gql`
  query getPolicyPolicyPersons($policyID: String!) {
    production {
      getPolicyPolicyPersons(policyID: $policyID) {
        firstName
        middleName
        lastName
        id
        typeList
      }
    }
  }
`;

export const getExportClaimsLOVs = gql`
  query getExportClaimsLOVs {
    claimManagement {
      getClaimsLovs {
        claimStatuses {
          id
          value
        }
      }
    }
    production {
      searchPolicies(
        pagination: { pageNumber: 1, pageSize: 1000 }
        statuses: ["Inforce", "InProgress", "Expired"]
      ) {
        items {
          id
          policyNumber
        }
      }
    }
  }
`;

export const searchClaimsForExport = gql`
  query searchClaimsForExport(
    $currentPage: Int!
    $currentPageSize: Int!
    $statuses: [String!]
    $policies: [String!]
    $claimDateStart: DateTime
    $claimDateEnd: DateTime
    $declarationDateStart: DateTime
    $declarationDateEnd: DateTime
    $createdOnStart: DateTime
    $createdOnEnd: DateTime
  ) {
    claimManagement {
      getClaims(
        keyword: ""
        orderBy: { attribute: "totalEstimation", descending: true }
        pagination: { pageNumber: $currentPage, pageSize: $currentPageSize }
        statuses: $statuses
        policies: $policies
        lines: []
        sublines: []
        plans: []
        companies: []
        insureds: []
        claimDateStart: $claimDateStart
        claimDateEnd: $claimDateEnd
        declarationDateStart: $declarationDateStart
        declarationDateEnd: $declarationDateEnd
        createdOnStart: $createdOnStart
        createdOnEnd: $createdOnEnd
      ) {
        paging {
          pageNumber
          pageSize
          totalCount
        }
        items {
          claim {
            id
            claimNumber
            claimDate
            declarationDate
            createdOn
            status
            statusReason

            policy {
              id
              policyNumber
              policyStatus
              policyEffectiveDate
              policyExpiryDate
              policyIssueDate
              policyCurrency {
                title
                symbol
              }
            }
            insured {
              firstName
              middleName
              lastName
            }
          }
        }
      }
    }
  }
`;

export const getClaimDetailsForExport = gql`
  query getClaimDetailsForExport($id: String!) {
    claimManagement {
      getClaimDetailsById(id: $id) {
        claimCoverDetails {
          estimationClaim
          approvedAmountClaim
          paidAmountClaim
        }
        claimDetails {
          claimNotes
          claimCurrency {
            symbol
          }
        }
      }
    }
  }
`;

export const getReinsurerExportLovs = gql`
  query REINSURERS_EXPORT_LOVS {
    BusinessPartnerStatusList: __type(name: "BusinessPartnerStatus") {
      enumValues {
        name
      }
    }
    salesforce {
      getRelatedCompanies {
        id
        title
        code
      }
    }
  }
`;

export const getTreatiesExportLovs = gql`
  query TREATIES_EXPORT_LOVS {
    TreatyTypeList: __type(name: "TreatyType") {
      enumValues {
        name
      }
    }
    TreatyStatusList: __type(name: "TreatyStatus") {
      enumValues {
        name
      }
    }
    salesforce {
      getRelatedCompanies {
        id
        title
      }
    }
  }
`;

export const exportTreaties = gql`
  query EXPORT_TREATIES(
    $pagination: PaginationInput!
    $companies: [String!]
    $types: [String!]
    $statuses: [String!]
    $effectiveDateFrom: DateTime
    $effectiveDateTo: DateTime
    $createdOnDateFrom: DateTime
    $createdOnDateTo: DateTime
    $OrderBy: OrderByInput
    $keyword: String
  ) {
    reinsurance {
      searchTreaties(
        keyword: $keyword
        pagination: $pagination
        orderBy: $OrderBy
        companies: $companies
        statuses: $statuses
        types: $types
        leaderReinsurers: null
        effectiveDateFrom: $effectiveDateFrom
        effectiveDateTo: $effectiveDateTo
        createdOnDateFrom: $createdOnDateFrom
        createdOnDateTo: $createdOnDateTo
      ) {
        items {
          id
          code
          name
          type
          status
          treatyEffectiveDate
          treatyExpiryDate
          underwritingLimit
          substandardLimit
          claimAdviseLimit
          relatedCompany {
            title
          }
          leaderReinsurer {
            fullName
          }
          currency {
            title
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const getRelatedCompaniesQuery = gql`
  query GetRelatedCompanies {
    salesforce {
      getRelatedCompanies {
        id
        code
        title
      }
    }
  }
`;

export const getCurrenciesQuery = gql`
  query GetCurrencies {
    core {
      getCurrencies {
        id
        title
        code
        symbol
      }
    }
  }
`;

export const searchReinsurers = gql`
  query searchReinsurers(
    $pagination: PaginationInput!
    $companies: [String!]
    $statuses: [String!]
    $isLocal: Boolean
    $createdDateFrom: DateTime
    $createdDateTo: DateTime
    $orderBy: OrderByInput
    $keyword: String
  ) {
    reinsurance {
      searchReinsurers(
        pagination: $pagination
        orderBy: $orderBy
        companies: $companies
        statuses: $statuses
        isLocal: $isLocal
        createdOnStart: $createdDateFrom
        createdOnEnd: $createdDateTo
        keyword: $keyword
      ) {
        items {
          id
          code
          fullName
          relatedCompany
          auxiliaryAccount
          status
          registerationNumber
          createdOn
          modifiedOn
          person {
            email
            phoneDetails {
              phoneNumber
            }
          }
          company {
            title
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const createTreatyMutation = gql`
  mutation CreateTreaty($createTreatyInput: CreateTreatyInput!) {
    reinsurance {
      createTreaty(createTreatyInput: $createTreatyInput)
    }
  }
`;

export const getTreatyReinsurersAndListQuery = gql`
  query getTreatyReinsurersAndList(
    $treatyId: String!
    $currentPage: Int!
    $currentPageSize: Int!
    $statuses: [String!]
    $isLocal: Boolean
    $createdDateFrom: DateTime
    $createdDateTo: DateTime
    $Attribute: String!
    $Descending: Boolean!
    $keywordSearch: String
    $companies: [String!]
  ) {
    reinsurance {
      getTreatyReinsurers(treatyId: $treatyId) {
        id
        treatyID
        reinsurerID
        isLeader
        sharePercentage
        createdBy
        createdOn
        modifiedBy
        modifiedOn
        reinsurer {
          id
          fullName
          code
          isLocal
          isCompany
          isRegistered
          registerationNumber
          registerationExpiryDate
          relatedCompany
          status
          auxiliaryAccount
          taxAuxiliaryAccount
          personId
          hasAccessToAllInsured
          totalCreditLimitReached
          maxCreditLimitAllowed
          maxCreditLimitAllowedCurrency
          createdBy
          createdOn
          modifiedBy
          modifiedOn
          type
        }
      }

      searchReinsurers(
        pagination: { pageNumber: $currentPage, pageSize: $currentPageSize }
        orderBy: { attribute: $Attribute, descending: $Descending }
        companies: $companies
        statuses: $statuses
        isLocal: $isLocal
        createdOnStart: $createdDateFrom
        createdOnEnd: $createdDateTo
        keyword: $keywordSearch
      ) {
        items {
          id
          code
          fullName
          relatedCompany
          currency {
            code
            symbol
            title
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

// Policy Distribution Queries
export const exportPolicyDistribution = gql`
  query ExportPolicyDistribution(
    $pagination: PaginationInput!
    $companies: [String!]
    $policies: [String!]
    $treaties: [String!]
    $effectiveDateFrom: DateTime
    $effectiveDateTo: DateTime
    $createdOnDateFrom: DateTime
    $createdOnDateTo: DateTime
  ) {
    reinsurance {
      exportPolicyDistributions(
        pagination: $pagination
        companies: $companies
        policies: $policies
        treaties: $treaties
        effectiveDateFrom: $effectiveDateFrom
        effectiveDateTo: $effectiveDateTo
        createdOnDateFrom: $createdOnDateFrom
        createdOnDateTo: $createdOnDateTo
      ) {
        items {
          treaties {
            policy {
              id
              policyNumber
            }
            policyPlanCover {
              planCover {
                cover {
                  name
                }
              }
            }
            treaty {
              id
              code
              name
              currency {
                title
                symbol
              }
            }
            layerType {
              title
            }
            layerOrder
            excessAmount
            minimumLayerLimitPolicyCurrency
            maximumLayerLimitPolicyCurrency
            retentionLimitPolicyCurrency
            retainedSumInsured
            retainedSumInsuredBasic
            retainedSumInsuredSecondary
            cededSumInsured
            cededSumInsuredBasic
            cededSumInsuredSecondary
            retainedNetPremium
            retainedNetPremiumBasic
            retainedNetPremiumSecondary
            cededNetPremium
            cededNetPremiumBasic
            cededNetPremiumSecondary
            comission
            commissionBasic
            commissionSecondary
          }
          facultatives {
            policy {
              id
              policyNumber
            }
            policyPlanCover {
              planCover {
                cover {
                  name
                }
              }
            }
            facultative {
              currency {
                symbol
              }
            }
            cededSumInsured
            cededSumInsuredBasic
            cededSumInsuredSecondary
            cededNetPremium
            cededNetPremiumBasic
            cededNetPremiumSecondary
            commission
            commissionBasic
            commissionSecondary
          }
        }
      }
    }
  }
`;

export const getPolicies = gql`
  query GetPolicies {
    production {
      getAllPolicies {
        id
        code
        policyNumber
      }
    }
  }
`;

export const getTreaties = gql`
  query GetTreaties {
    reinsurance {
      getAllTreaties {
        id
        code
        name
      }
    }
  }
`;

export const reactivateTreatyMutation = gql`
  mutation ReactivateTreaty($treatyId: String!, $expiryDate: DateTime!) {
    reinsurance {
      reactivateTreaty(treatyId: $treatyId, expiryDate: $expiryDate)
    }
  }
`;

// Currency Exchange Rate Queries
export const validateCurrencyEffectiveDate = gql`
  query ValidateCurrencyEffectiveDate(
    $effectiveDate: DateTime!
    $pagination: PaginationInput!
    $orderBy: OrderByInput
  ) {
    core {
      ValidateCurrencyEffectiveDate(
        effectiveDate: $effectiveDate
        pagination: $pagination
        orderBy: $orderBy
      ) {
        items {
          baseCurrency
          effectiveDate
          id
          rate
          baseCurrencyNavigation {
            code
            id
            title
            titleAr
            symbol
          }
          targetCurrencyNavigation {
            code
            id
            title
            titleAr
            symbol
          }
          createdBy
          createdOn
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const getDistinctEffectiveDates = gql`
  query GetDistinctEffectiveDates {
    core {
      GetDistinctEffectiveDates
    }
  }
`;

export const searchExchangeRates = gql`
  query searchExchangeRates(
    $baseCurrencies: [String!]
    $pagination: PaginationInput!
    $keyword: String
    $orderBy: OrderByInput
    $effectiveOnStart: DateTime
    $effectiveOnEnd: DateTime
  ) {
    core {
      searchExchangeRates(
        baseCurrencies: $baseCurrencies
        pagination: $pagination
        keyword: $keyword
        orderBy: $orderBy
        effectiveOnStart: $effectiveOnStart
        effectiveOnEnd: $effectiveOnEnd
      ) {
        items {
          id
          baseCurrency
          targetCurrency
          rate
          effectiveDate
          baseCurrencyNavigation {
            code
            title
          }
          targetCurrencyNavigation {
            code
            title
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const createTaxation = gql`
  mutation createTaxation($taxationInput: CreateTaxationInput!) {
    core {
      createTaxation(taxationInput: $taxationInput)
    }
  }
`;

export const getLatestTaxationByLine = gql`
  query getLatestTaxationByLine($lineId: String!) {
    core {
      getLatestTaxationByLine(lineId: $lineId) {
        applicableToAllPlans
        code
        createdBy
        createdOn
        effectiveFrom
        effectiveTo
        fixedStamp
        fixedStampCurrency
        id
        isLatest
        lineID
        modifiedBy
        modifiedOn
        municipalityTax
        proportionalStamp
        reinsuranceTax
        taxOnCommission
      }
    }
  }
`;

export const getLines = gql`
  query getLines(
    $keyword: String
    $pagination: PaginationInput
    $orderBy: OrderByInput
    $statuses: [String!]
    $createdOnStart: DateTime
    $createdOnEnd: DateTime
  ) {
    planConfig {
      getLines(
        keyword: $keyword
        pagination: $pagination
        orderBy: $orderBy
        statuses: $statuses
        createdOnStart: $createdOnStart
        createdOnEnd: $createdOnEnd
      ) {
        items {
          id
          code
          name
          status
        }
      }
    }
  }
`;

export const searchTaxations = gql`
  query searchTaxations(
    $keyword: String
    $pagination: PaginationInput
    $orderBy: OrderByInput
    $lines: [String!]
    $effectiveDateFrom: DateTime
    $effectiveDateTo: DateTime
    $createdOnFrom: DateTime
    $createdOnTo: DateTime
  ) {
    core {
      searchTaxations(
        keyword: $keyword
        pagination: $pagination
        orderBy: $orderBy
        lines: $lines
        effectiveDateFrom: $effectiveDateFrom
        effectiveDateTo: $effectiveDateTo
        createdOnFrom: $createdOnFrom
        createdOnTo: $createdOnTo
      ) {
        items {
          id
          applicableToAllPlans
          code
          createdBy
          createdOn
          modifiedOn
          effectiveFrom
          effectiveTo
          fixedStamp
          fixedStampCurrency
          isLatest
          lineID
          municipalityTax
          proportionalStamp
          reinsuranceTax
          taxOnCommission
          fixedStampCurrencyValue {
            code
            symbol
            title
          }
          line {
            id
            code
            name
            abbreviation
          }
          taxationPlansSpecific {
            id
            planID
            fixedStamp
            fixedStampCurrency
            proportionalStamp
            municipalityTax
            taxOnCommission
            reinsuranceTax
            fixedStampCurrencyValue {
              id
              title
              symbol
            }
            plan {
              id
              code
              name
            }
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const exportBusinessPartners = gql`
  query SearchBusinessPartners(
    $keyword: String
    $pagination: PaginationInput
    $orderBy: OrderByInput
    $companies: [String!]
    $types: [String!]
    $statuses: [String!]
    $isLocal: Boolean
    $isCompany: Boolean
    $isRegistered: Boolean
    $createdOnFrom: DateTime
    $createdOnTo: DateTime
  ) {
    salesforce {
      searchBusinessPartners(
        keyword: $keyword
        pagination: $pagination
        orderBy: $orderBy
        companies: $companies
        types: $types
        statuses: $statuses
        isLocal: $isLocal
        isCompany: $isCompany
        isRegistered: $isRegistered
        createdOnFrom: $createdOnFrom
        createdOnTo: $createdOnTo
      ) {
        paging {
          pageNumber
          pageSize
          totalCount
        }
        items {
          id
          code
          fullName
          status
          type
          relatedCompany
          isLocal
          isCompany
          isRegistered

          registerationNumber
          registerationExpiryDate
          taxAuxiliaryAccount
          auxiliaryAccount
          hasAccessToAllInsured
          maxCreditLimitAllowedCurrency
          maxCreditLimitAllowed

          person {
            code
          }
        }
      }
    }
  }
`;

export const getExportBusinessPartnersLovs = gql`
  query {
    BusinessPartnerStatuses: __type(name: "BusinessPartnerStatus") {
      enumValues {
        name
      }
    }
    BusinessPartnerTypes: __type(name: "BusinessPartnerType") {
      enumValues {
        name
      }
    }
  }
`;

export const getBusinessPartnerLovs = gql`
  query GetBusinessPartnerLovs {
    salesforce {
      getActivePersons {
        id
        fullName
        email
        phoneDetails {
          phoneNumber
          phoneType
        }
        isTaxable
      }

      getRelatedCompanies {
        id
        code
        title
      }
    }

    core {
      getCountries {
        id
        title
        code
      }

      getTitles {
        id
        title
        code
      }

      getZones {
        id
        title
        code
      }

      getCurrencies {
        id
        title
        code
        symbol
      }
    }

    BusinessPartnerType: __type(name: "BusinessPartnerType") {
      name
      enumValues {
        name
      }
    }

    salesforce {
      getActivePersonsWithoutBusinessPartners {
        id
        fullName
        status
      }
    }
  }
`;

export const getActiveLinePlans = gql`
  query getActiveLinePlans($lineID: String!) {
    planConfig {
      getActiveLinePlans(lineID: $lineID) {
        id
        name
        code
      }
    }
  }
`;

export const getTaxationPlanSpecificById = gql`
  query getTaxationPlanSpecificById($taxationPlanSpecificId: String!) {
    core {
      getTaxationPlanSpecificById(
        taxationPlanSpecificId: $taxationPlanSpecificId
      ) {
        id
        taxationID
        lineID
        planID
        fixedStamp
        fixedStampCurrency
        proportionalStamp
        municipalityTax
        taxOnCommission
        reinsuranceTax
        fixedStampCurrencyValue {
          id
          title
          symbol
        }
        line {
          id
          code
          name
        }
        plan {
          id
          code
          name
        }
      }
    }
  }
`;

export const getInActiveBusinessPartnerLines = gql`
  query getInActiveBusinessPartnerLines($businessPartnerId: String!) {
    salesforce {
      getInActiveBusinessPartnerLines(buisnessPartnerId: $businessPartnerId) {
        id
        lineID
        status
        line {
          code
          name
          status
        }
      }
    }
  }
`;

export const getActiveBusinessPartnerLines = gql`
  query getActiveBusinessPartnerLines($businessPartnerId: String!) {
    salesforce {
      getActiveBusinessPartnerLines(buisnessPartnerId: $businessPartnerId) {
        id
        lineID
        status
        line {
          code
          id
          name
          status
        }
      }
    }
  }
`;

export const getDefaultCommissionLovs = gql`
  query getDefaultCommissionLovs($id: String!) {
    # -----------------------------
    # MAIN DRAWER ENTITY
    # -----------------------------
    salesforce {
      getBusinessPartnerLineDetails(businessPartnerLineID: $id) {
        id
        lineID
        creditLimit
        creditLimitCurrency
        creditLimitCurrencyValue {
          id
          title
          symbol
        }
        gracePeriod
        commissionType
        commissionAmount
        commissionAmountCurrency
        commissionAmountCurrencyValue {
          id
          title
          symbol
        }
        commissionApplicableOn
        commissionApplicableOnValue {
          id
          title
        }
        commissionRate
        line {
          name
          code
        }
        businessPartner {
          id
        }
        status
        createdBy
        createdOn
        modifiedBy
        modifiedOn
      }
    }

    # -----------------------------
    # CURRENCIES
    # -----------------------------
    core {
      getCurrencies {
        id
        title
        symbol
      }
    }

    # -----------------------------
    # COMMISSION TYPE ENUM
    # -----------------------------
    Core_CommissionTypes: __type(name: "CommissionType") {
      enumValues {
        name
      }
    }

    # -----------------------------
    # COMMISSION APPLICABLE ON
    # -----------------------------
    planConfig {
      getCommissionApplicableOnOptions {
        id
        code
        title
        createdOn
        modifiedOn
        status
      }
    }
  }
`;

export const getAssignPlansLovs = gql`
  query getAssignPlansLovs($buisnessPartnerId: String!) {
    planConfig {
      getCommissionApplicableOnOptions {
        id
        code
        title
        createdOn
        modifiedOn
        status
      }
    }

    core {
      getCurrencies {
        id
        title
        symbol
      }
    }

    Core_CommissionTypes: __type(name: "CommissionType") {
      enumValues {
        name
      }
    }

    salesforce {
      getActiveBusinessPartnerLines(buisnessPartnerId: $buisnessPartnerId) {
        businessPartnerID
        commissionAmount
        commissionAmountCurrency
        commissionApplicableOn
        commissionRate
        commissionType
        createdBy
        createdOn
        creditLimit
        creditLimitCurrency
        creditLimitReached
        gracePeriod
        id
        lineID
        modifiedBy
        modifiedOn
        status
        line {
          abbreviation
          abbreviationArabic
          code
          createdBy
          createdOn
          id
          modifiedBy
          modifiedOn
          name
          nameArabic
          status
        }
      }
    }
  }
`;

export const getPlansCommissionLovs = gql`
  query getPlansCommissionLovs(
    $businessPartnerPlanID: String!
    $includeDetails: Boolean!
  ) {
    planConfig {
      getCommissionApplicableOnOptions {
        id
        code
        title
        createdOn
        modifiedOn
        status
      }
    }

    core {
      getCurrencies {
        id
        title
        symbol
      }
    }

    Core_CommissionTypes: __type(name: "CommissionType") {
      enumValues {
        name
      }
    }

    salesforce {
      getBusinessPartnerPlanDetails(
        businessPartnerPlanID: $businessPartnerPlanID
      ) @include(if: $includeDetails) {
        id
        commissionType
        commissionRate
        commissionAmount
        commissionAmountCurrency
        commissionApplicableOn
        activeFrom
        activeTo

        businessPartnerLine {
          commissionType
          commissionRate
          commissionAmount
          commissionAmountCurrency
          commissionApplicableOn
        }

        plan {
          commissionApplicable
          commissionType
          commissionRate
          commissionAmount
          commissionAmountCurrency
          commissionApplicableOn
        }
      }
    }
  }
`;

export const getBusinessPartnerLineDetails = gql`
  query getBusinessPartnerLineDetails($businessPartnerLineID: String!) {
    salesforce {
      getBusinessPartnerLineDetails(
        businessPartnerLineID: $businessPartnerLineID
      ) {
        id
        commissionType
        commissionRate
        commissionAmount
        commissionAmountCurrency
        commissionApplicableOn
      }
    }
  }
`;

export const getUnassignedActivePlansByLine = gql`
  query getUnassignedActivePlansByLine(
    $businessPartnerID: String!
    $lineID: String!
  ) {
    salesforce {
      getUnassignedActivePlansByLine(
        businessPartnerID: $businessPartnerID
        lineID: $lineID
      ) {
        id
        code
        name
        effectiveFrom
        effectiveTo
        commissionType
        commissionRate
        commissionApplicable
        commissionAmount
        commissionAmountCurrency
        commissionApplicableOn
      }
    }
  }
`;

export const searchPolicyPersons = gql`
  query searchPolicyPersons(
    $currentPage: Int!
    $currentPageSize: Int!
    $selectedUsers: [String!]
    $selectedBusinessPartners: [String!]
    $effectiveOnStart: DateTime
    $effectiveOnEnd: DateTime
    $expiryOnStart: DateTime
    $expiryOnEnd: DateTime
    $issueDateStart: DateTime
    $issueDateEnd: DateTime
    $createdOnStart: DateTime
    $createdOnEnd: DateTime
    $Attribute: String!
    $Descending: Boolean!
    $statuses: [String!]
    $currencies: [String!]
  ) {
    production {
      searchPolicyPersons(
        pagination: { pageNumber: $currentPage, pageSize: $currentPageSize }
        orderBy: { attribute: $Attribute, descending: $Descending }
        users: $selectedUsers
        businessPartners: $selectedBusinessPartners
        effectiveOnStart: $effectiveOnStart
        effectiveOnEnd: $effectiveOnEnd
        expiryOnStart: $expiryOnStart
        expiryOnEnd: $expiryOnEnd
        issueDateStart: $issueDateStart
        issueDateEnd: $issueDateEnd
        createdOnStart: $createdOnStart
        createdOnEnd: $createdOnEnd
        statuses: $statuses
        currencies: $currencies
      ) {
        paging {
          pageNumber
          pageSize
          totalCount
        }
        items {
          email
          policy {
            policyNumber
            policyEffectiveDate
            policyExpiryDate
            policyStatus
            policyCurrency {
              symbol
            }
            plan {
              code
              name
            }
          }
          passportNumber
          insuredPolicyQuoteTravels {
            policyVersionState
            coverSumInsured
            coverTotalPremium
          }
          firstName
          lastName
          phoneNumber
          address {
            addressDetails
            city
          }
          dateOfBirth
          relation
        }
      }
    }
  }
`;
